import React, { useEffect, useRef, useState } from "react";
import {
  CustomLabel,
  DownloadTemplate,
  FileUploaderNormal,
  DownloadTemplateNewTab,
  HeaderDivider,
} from "../../../../../utilities/utll";
import { Col, Row } from "reactstrap";
import FileUploadDragger from "../../../../../common/dragUpload";
import { Button, Checkbox, message, Modal, Tooltip, Typography } from "antd";
import {
  DownloadOutlined,
  QuestionCircleOutlined,
  EyeFilled,
  DeleteOutlined,
} from "@ant-design/icons";
import { uploadDocApi } from "../../../../../services/irn";
import { useDocumentStore } from "../../../../../store/vendorRegistrationStore/useDocumentStore";
import useTabsSystemStore from "../../../../../store/RenderTabStore";
import { useIrnStore } from "../../../../../store/useIrnstore";
import ImagePreviewModal from "../../../../IRNRegister/ListRegister/imageModal";
import ApproveReject from "../../../../../components/approveReject/ApproveReject";
import { useBasicDataFormStore } from "../../../../../store/vendorRegistrationStore/useBasicDataFormStore";
import LuxuryCheckbox from "../../../../../common/Checkbox";
import { useVendorMasterStore } from "../../../../../store/useVendorMasterStore";
import { TEMPLATEBASEURL } from "../../../../../utilities/api";

export const DocumentForm = () => {
  const {
    handleInputChange,
    documnetData,
    showModal,
    modal,
    errors,
    submitApplication,
    deleteDocumentFile,
  } = useDocumentStore();
  const { checkBoxes, setCheckbox, vendorDetailByGuid } =
    useVendorMasterStore();
  const { Paragraph, Title, Text } = Typography;
  const [accepted, setAccepted] = useState(false);
  const [signaturePath, setSignaturePath] = useState("");
  const { openTabs, addNewTab, setActiveTab, closeTab } = useTabsSystemStore();
  const locationCode = localStorage.getItem("locationCode");
  const submitted = localStorage.getItem("submitted") === "Yes";
  const approve = localStorage.getItem("showApprove") === "true";
  const showStep4 = localStorage.getItem("ShowStep4") === "Yes";
  const { VendorType } = vendorDetailByGuid?.Vendor || {};

  const { basicData } = useBasicDataFormStore();

  const { downloadDoc } = useIrnStore();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const GUID = localStorage.getItem("vendorGUID");

  useEffect(() => {
    if (!submitted && GUID && locationCode)
      handleInputChange("locationCode", locationCode);
    handleInputChange("vendorGUID", GUID);
  }, [locationCode, GUID]);

  const handleFileUpload = async (info, percent, type) => {
    let uploadedFile = info;

    if (!(uploadedFile instanceof File)) return;

    const originalName = uploadedFile.name;

    // 🔹 Sanitize filename (remove spaces & special chars)
    const sanitizedFileName = originalName
      .replace(/\s+/g, "") // remove spaces
      .replace(/[^a-zA-Z0-9_.-]/g, ""); // remove special chars

    uploadedFile = new File([uploadedFile], sanitizedFileName, {
      type: uploadedFile.type,
      lastModified: uploadedFile.lastModified,
    });

    try {
      const res = await uploadDocApi(uploadedFile, percent);
      if (type === "signature") {
        setSignaturePath(res);
      }
      if (res && type !== "signature") {
        handleInputChange(type, res);
      }
    } catch (error) {
      console.error("File upload failed", error);
      message.error("File upload failed. Please try again.");
    }
  };
  const handleSubmit = async () => {
    const vendorGUID =
      localStorage.getItem("vendorGUID") || documnetData.vendorGUID;
    try {
      if (signaturePath === "") {
        message.error("Please upload signature file");
        return;
      }
      const response = await submitApplication({ vendorGUID, signaturePath });
      if (response?.IsSuccess) {
        showModal(false);
        message.success("Application submitted successfully.");
        const isVendorListOpen = openTabs.some((tab) => tab.key === "form_34");
        if (!isVendorListOpen) {
          addNewTab([
            ...openTabs,
            {
              closable: true,
              key: "form_34",
              label: "View Vendor Profile",
            },
          ]);
        }
        setActiveTab("form_34");
        closeTab("new_registration");
      }
      localStorage.removeItem("vendorGUID");
      localStorage.removeItem("locationCode");
      localStorage.removeItem("submitted");
    } catch (err) {
      message.error("Something went wrong!");
    }
  };

  const handleDownload = async (name) => {
    try {
      setLoading(true);
      const response = await downloadDoc(name);
      const extension = name.split(".").pop().toLowerCase();
      let type = "other";

      if (["jpg", "JPG", "jpeg", "png", "webp"].includes(extension)) {
        type = "image";
      } else if (extension === "pdf") {
        type = "pdf";
      }

      setImageUrl(response);
      setFileName(name);
      setFileType(type);
      setOpen(true);
    } catch (error) {
      console.error("Error downloading document:", error);
      message.error("Failed to download document.");
    } finally {
      setLoading(false);
    }
  };

  const allChecked = Object.values(checkBoxes).every(Boolean);

  return (
    <>
      <HeaderDivider title="Document" isShort />
      <Row style={{ marginTop: "20px" }}>
        <Col xl={3} md={6}>
          <CustomLabel children={"Pan Details"} isImportnt={true} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "panFile")
            }
            onRemove={() => handleInputChange("panFile", "")}
            disabled={submitted}
            fileUrl={documnetData.documents[0]?.panFile}
          />
          {documnetData.documents[0]?.panFile && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.panFile)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("panFile")}
                />
              )}
            </div>
          )}
          {errors?.panFile && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.panFile}
            </span>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel
            children={"GST Registration Document"}
            isImportnt={basicData.gstRegistration}
          />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "gstFile")
            }
            onRemove={() => handleInputChange("gstFile", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.gstFile && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.gstFile)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("gstFile")}
                />
              )}
            </div>
          )}
          {errors?.gstFile && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.gstFile}
            </span>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Cancelled Cheque"} isImportnt={true} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "cancelledCheque")
            }
            onRemove={() => handleInputChange("cancelledCheque", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.cancelledCheque && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.cancelledCheque)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("cancelledCheque")}
                />
              )}
            </div>
          )}
          {errors?.cancelledCheque && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.cancelledCheque}
            </span>
          )}
        </Col>
        {VendorType !== "ZAEX" && (
          <Col xl={3} md={6}>
            <CustomLabel
              children={"FSSAI Certificate"}
              isImportnt={basicData.fssaiRegistration}
            />
            <FileUploaderNormal
              onChange={(info, percent) =>
                handleFileUpload(info, percent, "fssaiCertificate")
              }
              onRemove={() => handleInputChange("fssaiCertificate", "")}
              disabled={submitted}
            />
            {documnetData.documents[0]?.fssaiCertificate && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",

                  gap: "20px",
                }}
              >
                <a
                  style={{
                    color: "#1890ff",
                    cursor: "pointer",
                    textDecoration: "underline",
                    marginTop: 5,
                  }}
                  onClick={() =>
                    handleDownload(documnetData.documents[0]?.fssaiCertificate)
                  }
                >
                  View File
                </a>
                {!submitted && (
                  <DeleteOutlined
                    style={{
                      color: "#ff4d4f",
                      fontSize: "16px",
                      cursor: "pointer",
                    }}
                    title="Delete File"
                    onClick={() => deleteDocumentFile("fssaiCertificate")}
                  />
                )}
              </div>
            )}
            {errors?.fssaiCertificate && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.fssaiCertificate}
              </span>
            )}
          </Col>
        )}
      </Row>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Organic Category"} isImportnt={false} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "organicCategory")
            }
            onRemove={() => handleInputChange("organicCategory", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.organicCategory && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.organicCategory)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("organicCategory")}
                />
              )}
            </div>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Diabetic Category"} isImportnt={false} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "diabeticCategory")
            }
            onRemove={() => handleInputChange("diabeticCategory", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.diabeticCategory && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.diabeticCategory)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("diabeticCategory")}
                />
              )}
            </div>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"VAT/TIN/CST Number"} isImportnt={false} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "vattincstNumber")
            }
            onRemove={() => handleInputChange("vattincstNumber", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.vattincstNumber && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.vattincstNumber)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("vattincstNumber")}
                />
              )}
            </div>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"Artical of Association"} isImportnt={false} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "articalOfAssociation")
            }
            onRemove={() => handleInputChange("articalOfAssociation", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.articalOfAssociation && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(
                    documnetData.documents[0]?.articalOfAssociation,
                  )
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("articalOfAssociation")}
                />
              )}
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Partnership Deed"} isImportnt={false} />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "partnershipDeed")
            }
            onRemove={() => handleInputChange("partnershipDeed", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.partnershipDeed && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.partnershipDeed)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("partnershipDeed")}
                />
              )}
            </div>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel
            children={"Agreement/SOW/Job of work"}
            isImportnt={VendorType === "ZAEX" ? true : false}
          />
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "sowDocument")
            }
            onRemove={() => handleInputChange("sowDocument", "")}
            disabled={submitted}
          />
          {documnetData.documents[0]?.sowDocument && (
            <div
              style={{
                display: "flex",
                alignItems: "center",

                gap: "20px",
              }}
            >
              <a
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: 5,
                }}
                onClick={() =>
                  handleDownload(documnetData.documents[0]?.sowDocument)
                }
              >
                View File
              </a>
              {!submitted && (
                <DeleteOutlined
                  style={{
                    color: "#ff4d4f",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  title="Delete File"
                  onClick={() => deleteDocumentFile("sowDocument")}
                />
              )}
            </div>
          )}
          {errors?.sowDocument && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.sowDocument}
            </span>
          )}
        </Col>
        {submitted && showStep4 && (
          <Col xl={3} lg={3} md={6} sm={12} style={{ marginTop: 20 }}>
            <LuxuryCheckbox
              id={"document"}
              label="Checked"
              checked={checkBoxes.document}
              onChange={(e) => setCheckbox("document", !checkBoxes.document)}
              disabled={!approve}
            />
          </Col>
        )}
      </Row>

      {/* <HeaderDivider title="RTGS/ NEFT/ E-mandate Form || MSME Documents" isShort xl={6} /> */}
      <Row style={{ marginBottom: 0 }}>
        <Col xl={4} lg={4} md={12}>
          <HeaderDivider title="RTGS / NEFT / E-mandate Form" isShort />
        </Col>

        <Col xl={4} lg={4} md={12}>
          <HeaderDivider
            title={
              basicData?.msmeRegistration
                ? "MSME Certificate"
                : "MSME Declaration"
            }
            isShort
          />
        </Col>
        <Col xl={4} lg={4} md={12}>
          <HeaderDivider title="Business Code of Conduct" isShort />
        </Col>
      </Row>

      <Row>
        <Col xl={4} lg={4}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div>
              <FileUploaderNormal
                onChange={(info, percent) =>
                  handleFileUpload(info, percent, "rtgsDetails")
                }
                onRemove={() => handleInputChange("rtgsDetails", "")}
                disabled={submitted}
              />
            </div>
            <div
              style={{
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Button
                  color="purple"
                  icon={<DownloadOutlined />}
                  variant="solid"
                  onClick={() =>
                    DownloadTemplate(
                      `${TEMPLATEBASEURL}E_Mandate_RTGS_NEFT_Form.doc`,
                      "E_Mandate_RTGS_NEFT_Form.doc",
                    )
                  }
                >
                  Download Template
                </Button>
                <Tooltip title="RTGS / NEFT / E-mandate Form">
                  <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                    <Button icon={<QuestionCircleOutlined />} />
                  </span>
                </Tooltip>
              </div>
              <div>
                {documnetData.documents[0]?.rtgsDetails && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <a
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: 10,
                      }}
                      onClick={() =>
                        handleDownload(documnetData.documents[0]?.rtgsDetails)
                      }
                    >
                      View File
                    </a>
                    {!submitted && (
                      <DeleteOutlined
                        style={{
                          color: "#ff4d4f",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        title="Delete File"
                        onClick={() => deleteDocumentFile("rtgsDetails")}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>

        <Col xl={4} lg={4}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div>
              <FileUploaderNormal
                onChange={(info, percent) =>
                  handleFileUpload(info, percent, "msmeDocument")
                }
                onRemove={() => handleInputChange("msmeDocument", "")}
                disabled={submitted}
              />
            </div>
            <div
              style={{
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Button
                  color="purple"
                  icon={<DownloadOutlined />}
                  variant="solid"
                  onClick={() =>
                    DownloadTemplate(
                      `${TEMPLATEBASEURL}MSME_Declaration_Letter.doc`,
                      "MSME_Declaration_Letter.doc",
                    )
                  }
                >
                  Download Template
                </Button>
                <Tooltip title="Upload MSME certificate (MSME Registered) otherwise declaration as per attached template.">
                  <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                    <Button icon={<QuestionCircleOutlined />} />
                  </span>
                </Tooltip>
              </div>
              <div>
                {documnetData.documents[0]?.msmeDocument && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <a
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: 10,
                      }}
                      onClick={() =>
                        handleDownload(documnetData.documents[0]?.msmeDocument)
                      }
                    >
                      View File
                    </a>
                    {!submitted && (
                      <DeleteOutlined
                        style={{
                          color: "#ff4d4f",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        title="Delete File"
                        onClick={() => deleteDocumentFile("msmeDocument")}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {errors?.msmeDocument && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.msmeDocument}
            </span>
          )}
        </Col>

        <Col xl={4} lg={4}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div>
              <FileUploaderNormal
                onChange={(info, percent) =>
                  handleFileUpload(info, percent, "businessCodeOfConduct")
                }
                onRemove={() => handleInputChange("businessCodeOfConduct", "")}
                disabled={submitted}
              />
            </div>
            <div
              style={{
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Button
                  color="purple"
                  icon={<DownloadOutlined />}
                  variant="solid"
                  onClick={() =>
                    DownloadTemplateNewTab(
                      `${TEMPLATEBASEURL}BusinessCodeofConduct.pdf`,
                      "BusinessCodeofConduct.pdf",
                    )
                  }
                >
                  Download Template
                </Button>
                {/* <Tooltip title="RTGS / NEFT / E-mandate Form">
            <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
              <Button icon={<QuestionCircleOutlined />} />
            </span>
          </Tooltip> */}
              </div>
              <div>
                {documnetData.documents[0]?.businessCodeOfConduct && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <a
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: 10,
                      }}
                      onClick={() =>
                        handleDownload(
                          documnetData.documents[0]?.businessCodeOfConduct,
                        )
                      }
                    >
                      View File
                    </a>
                    {!submitted && (
                      <DeleteOutlined
                        style={{
                          color: "#ff4d4f",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        title="Delete File"
                        onClick={() =>
                          deleteDocumentFile("businessCodeOfConduct")
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {errors?.businessCodeOfConduct && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.businessCodeOfConduct}
            </span>
          )}
        </Col>
      </Row>

      {/* <Row>
        <Col xl={4} lg={4}>
          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "nowrap",
            }}
          >
            <div
              style={{
                maxWidth: "27.5%",
                marginRight: "6%",
              }}
            >
              <FileUploaderNormal
                onChange={(info, percent) =>
                  handleFileUpload(info, percent, "rtgsDetails")
                }
                onRemove={() => handleInputChange("rtgsDetails", "")}
                disabled={submitted}
              />
            </div>

            <div
              style={{
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Button
                  color="purple"
                  icon={<DownloadOutlined />}
                  variant="solid"
                  onClick={() =>
                    DownloadTemplate(
                      `${TEMPLATEBASEURL}E_Mandate_RTGS_NEFT_Form.doc`,
                      "E_Mandate_RTGS_NEFT_Form.doc",
                    )
                  }
                >
                  Download Template
                </Button>
                <Tooltip title="RTGS / NEFT / E-mandate Form">
                  <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                    <Button icon={<QuestionCircleOutlined />} />
                  </span>
                </Tooltip>
              </div>
              <div>
                {documnetData.documents[0]?.rtgsDetails && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",

                      gap: "20px",
                    }}
                  >
                    <a
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: 10,
                      }}
                      onClick={() =>
                        handleDownload(documnetData.documents[0]?.rtgsDetails)
                      }
                    >
                      View File
                    </a>
                    {!submitted && (
                      <DeleteOutlined
                        style={{
                          color: "#ff4d4f",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        title="Delete File"
                        onClick={() => deleteDocumentFile("rtgsDetails")}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
        <Col xl={4} lg={4}>
          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "nowrap",
            }}
          >
            <div
              style={{
                maxWidth: "27.5%",
                marginRight: "6%",
              }}
            >
              <FileUploaderNormal
                onChange={(info, percent) =>
                  handleFileUpload(info, percent, "msmeDocument")
                }
                onRemove={() => handleInputChange("msmeDocument", "")}
                disabled={submitted}
              />
            </div>
            <div
              style={{
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Button
                  color="purple"
                  icon={<DownloadOutlined />}
                  variant="solid"
                  onClick={() =>
                    DownloadTemplate(
                      `${TEMPLATEBASEURL}MSME_Declaration_Letter.doc`,
                      "MSME_Declaration_Letter.doc",
                    )
                  }
                >
                  Download Template
                </Button>
                <Tooltip title="Upload MSME certificate (MSME Registered) otherwise declaration as per attached template.">
                  <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                    <Button icon={<QuestionCircleOutlined />} />
                  </span>
                </Tooltip>
              </div>
              <div>
                {documnetData.documents[0]?.msmeDocument && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",

                      gap: "20px",
                    }}
                  >
                    <a
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: 10,
                      }}
                      onClick={() =>
                        handleDownload(documnetData.documents[0]?.msmeDocument)
                      }
                    >
                      View File
                    </a>
                    {!submitted && (
                      <DeleteOutlined
                        style={{
                          color: "#ff4d4f",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        title="Delete File"
                        onClick={() => deleteDocumentFile("msmeDocument")}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {errors?.msmeDocument && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.msmeDocument}
            </span>
          )}
        </Col>
        <Col xl={4} lg={4}>
          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "nowrap",
            }}
          >
            <div
              style={{
                maxWidth: "27.5%",
                marginRight: "6%",
              }}
            >
              <FileUploaderNormal
                onChange={(info, percent) =>
                  handleFileUpload(info, percent, "businessCodeOfConduct")
                }
                onRemove={() => handleInputChange("businessCodeOfConduct", "")}
                disabled={submitted}
              />
            </div>

            <div
              style={{
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <div>
                <Button
                  color="purple"
                  icon={<DownloadOutlined />}
                  variant="solid"
                  onClick={() =>
                    DownloadTemplate(
                      `${TEMPLATEBASEURL}BusinessCodeofConduct.doc`,
                      "BusinessCodeofConduct.doc",
                    )
                  }
                >
                  Download Template
                </Button>
               
              </div>
              <div>
                {documnetData.documents[0]?.businessCodeOfConduct && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",

                      gap: "20px",
                    }}
                  >
                    <a
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        textDecoration: "underline",
                        marginTop: 10,
                      }}
                      onClick={() =>
                        handleDownload(
                          documnetData.documents[0]?.businessCodeOfConduct,
                        )
                      }
                    >
                      View File
                    </a>
                    {!submitted && (
                      <DeleteOutlined
                        style={{
                          color: "#ff4d4f",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                        title="Delete File"
                        onClick={() =>
                          deleteDocumentFile("businessCodeOfConduct")
                        }
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {errors?.businessCodeOfConduct && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.businessCodeOfConduct}
            </span>
          )}
        </Col>
      </Row> */}

      {/* <Row style={{ marginTop: "30px" }}>
        <Col xl={2} lg={2}>
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "businessCodeOfConduct")
            }
            onRemove={() => handleInputChange("businessCodeOfConduct", "")}
            disabled={submitted}
          />
          {errors?.businessCodeOfConduct && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.businessCodeOfConduct}
            </span>
          )}
        </Col>
        <Col
          xl={6}
          lg={6}
          style={{ marginBottom: 0, paddingBottom: 0, lineHeight: 1 }}
        >
          <div>
            <Button color="purple" icon={<DownloadOutlined />} variant="solid">
              Download Template
            </Button>
            <Tooltip title="Business Code of Conduct">
              <span style={{ marginTop: "1.35rem", marginLeft: "10px" }}>
                <Button icon={<QuestionCircleOutlined />} />
              </span>
            </Tooltip>
          </div>
          {documnetData.documents[0]?.businessCodeOfConduct && (
            <a
              style={{
                color: "#1890ff",
                cursor: "pointer",
                textDecoration: "underline",
                marginTop: 10,
              }}
              onClick={() =>
                handleDownload(documnetData.documents[0]?.businessCodeOfConduct)
              }
            >
              View File
            </a>
          )}
        </Col>
      </Row> */}
      <Modal
        open={modal}
        onCancel={() => showModal(false)}
        footer={null}
        centered
        width={600}
      >
        <Title level={4} style={{ textAlign: "center" }}>
          Terms & Conditions
        </Title>

        <div
          // ref={contentRef}
          // onScroll={handleScroll}
          style={{
            maxHeight: 300,
            overflowY: "auto",
            border: "1px solid #d9d9d9",
            padding: 16,
            marginBottom: 16,
          }}
        >
          {/* LARGE DUMMY CONTENT */}

          <Paragraph>
            <Text strong>I hereby declare and confirm the following:</Text>

            <ol style={{ marginTop: 12, paddingLeft: 20 }}>
              {VendorType !== "ZLOC" && (
                <li>
                  <Text strong>No Conflict of Interest</Text>
                  <Paragraph>
                    Neither I nor any employee or direct relation of any employee
                    of Hypermax City Private Limited is in any way connected as a
                    partner, shareholder, director, advisor, consultant, or
                    employee with the Company. I am not personally related to any
                    Employee, Officer, or Director of Hypermax City Private
                    Limited. I do not have any conflict of interest in entering
                    into a contract or association with the Company.
                  </Paragraph>
                </li>
              )}

              <li>
                <Text strong>Compliance and Undertaking</Text>
                <Paragraph>
                  I have taken note of the Code of Conduct and the Whistle
                  Blower Policy of the Company and undertake to inform the
                  Company, without delay, in case of any potential conflict of
                  interest or breach of the Code of Conduct in the future.
                </Paragraph>
              </li>

              {VendorType !== "ZLOC" && (
                <li>
                  <Text strong>Waiver of Claims</Text>
                  <Paragraph>
                    I irrevocably agree to waive any and all claims, demands,
                    suits, actions, causes of action, and rights whatsoever at law
                    or in equity, now existing or arising, relating to any accrued
                    and unpaid interest on delayed payments against our invoices
                    or any other agreement with your Company.
                  </Paragraph>
                  <Paragraph>
                    I further acknowledge and agree that I shall not commence or
                    prosecute in any way, or cause to be commenced or prosecuted,
                    any action in any court relating to any such accrued and
                    unpaid interest.
                  </Paragraph>
                </li>
              )}

              <li>
                <Text strong>Accuracy of Information</Text>
                <Paragraph>
                  The information furnished is correct to the best of my
                  knowledge and belief.
                </Paragraph>
              </li>
            </ol>
          </Paragraph>

          {/* Checkbox at the VERY END */}
          <div style={{ marginTop: 24 }}>
            <Checkbox
              // disabled={!scrolledToBottom}
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            >
              I have read and agree to the Terms & Conditions
            </Checkbox>

            {/* {!scrolledToBottom && (
              <div style={{ fontSize: 12, color: "#999", marginTop: 6 }}>
                Please scroll to the bottom to accept the terms.
              </div>
            )} */}
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <FileUploaderNormal
            onChange={(info, percent) =>
              handleFileUpload(info, percent, "signature")
            }
            onRemove={() => setSignaturePath("")}
            disabled={submitted}
            field="signature"
          />
          <Button
            type="primary"
            onClick={handleSubmit}
            style={{ marginTop: 20 }}
            disabled={!accepted || !signaturePath}
          >
            Final Submit
          </Button>
        </div>
      </Modal>
      {submitted && approve && <ApproveReject checked={allChecked} />}
      {open && (
        <ImagePreviewModal
          open={open}
          onClose={() => {
            setOpen(false);
            setImageUrl(null);
            setFileName("");
            setFileType("");
          }}
          imageUrl={imageUrl}
          fileName={fileName}
          fileType={fileType}
        />
      )}
    </>
  );
};
